export default {
    差价合约:'ETF CFD取引',
    把握全球:'世界で人気な100のETF CFDが取引可能です。株式ETF、債券・固定収入ETF、地域・国別テーマETF、業種・テーマETF、配当ETF、レバレッジ・特別ETFなど、世界中で人気の 100 種類のETF CFDを取引できます。ファンド口座が不要で、買い・売りの両建て、そしてレバレッジをサポートします。',
    即刻开户:'今すぐ口座開設',
    优势:'選ばれる理由',
    差价合约是一种:'ETF CFDは、世界の主要ETF銘柄にレバレッジを効かせて柔軟に投資できる手法です。価格変動を捉えたいトレーダーや、ポートフォリオの分散を図りたい方におすすめします。',
    品种丰富:'豊富なラインアップ',
    支持100:'世界中の人気ETF CFD100銘柄を取引可能',
    灵活交易:'柔軟な戦略',
    支持买入:'上昇も下降もチャンスに。ロング＆ショートポジションで取引。',
    无需持有:'実物資産の保有は不要',
    无需持有资产:'実物資産を保有せずに、ETFの価格変動を狙った取引が可能',
    杠杆交易:'レバレッジ取引が可能',
    杠杆配置:'最大5倍のレバレッジで資金効率を最適化',
    开设模拟账户:'今すぐデモ口座を開設',
    开设真实账户:'今すぐライブ口座を開設',
    如何开始交易:'取引までの流れ',
    注册账号:'口座開設はこちら',
    注册并登录:'登録後、マイページからご本人確認をお済ませください',
    下载MT5交易平台:'MT5をダウンロード',
    开通真实交易账号:'MetaTrader 5でライブ口座を開設してください',
    开始交易:'取引を開始',
    选择ETF:'豊富なETF CFD銘柄からお選びください',
    即刻交易:'今すぐ取引を始める',
    差价合约相关问题:'ETF CFD取引に関するよくある質問',
    有什么区别:'1. ETF CFDは従来のETFとどう異なりますか？',
    是差价合约交易:'ETF CFDは、実際のファンドを保有することなくETFの価格変動を取引する銘柄です。ETF実物資産の保有・受渡しの必要がありません。ETF CFDは、短期取引やレバレッジを効かせた取引、さらにはロング・ショートの両方向から取引戦略を立てられます。',
    购买ETF才能交易:'2. ETFを取引するために、実際にETFを所有しなければなりませんか？',
    通过EBC提供的ETF:'いいえ。EBCのETF CFD銘柄なら、ETFの株式を保有することなく、プラットフォーム上で直接ETFの価格変動でお取引いただけます。',
    交易会收取哪些费:'3. ETF CFD取引にはどのような手数料がかかりますか？',
    您无需支付传统ETF的管理费:'従来のETFの管理報酬や売買委託手数料はかかりません。主な費用は、売買スプレッドと翌日持ち越しのスワップ金利です。手数料はプラットフォーム上でリアルタイムに表示されますので、取引環境の透明性を保証いたします。',
    可以做空吗:'4. ETF CFDの空売りはできますか？',
    与传统ETF只能做多不:'可能です。従来のETFがロングポジションのみであることに対し、ETF CFDは空売りも取引可能です。これにより、相場の変動や下落局面でも柔軟な戦略を取ることができます。',
    适合新手交易者:'5. ETF CFD取引は初心者に向いていますか？',
    CFD产品具有杠杆属性:'ETF CFD取引はレバレッジ商品であり、一定の取引経験とリスクに理解を持つ方に適しています。初心者の方は、実際の取引を始める前にデモ口座で練習し、商品特性について十分に理解することをおすすめいたします。',
    市场报价:'取引銘柄とスプレッド一覧はこちら',
    查看所有产品:'取引銘柄とスプレッド一覧はこちら',
}